"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _ = require("lodash");
const angular = require("@wk/angular");
const ngRoute = require("@wk/angular-route");
const ngAnimate = require("@wk/angular-animate");
const ngResource = require("@wk/angular-resource");
const ngSanitize = require("@wk/angular-sanitize");
const uiBootstrap = require("angular-ui-bootstrap");
const ngFileUpload = require("ng-file-upload");
const angularGrowl = require("angular-growl-v2");
const index_controller_1 = require("./index.controller");
const afbeeldingen_controller_1 = require("./views/afbeeldingen.controller");
const folio_controller_1 = require("./views/folio.controller");
const instellingen_controller_1 = require("./views/instellingen.controller");
const login_controller_1 = require("./views/login.controller");
const settingsservice_1 = require("./modules/settings/services/settingsservice");
const toolbox_1 = require("./modules/common/services/toolbox");
const applicationservice_1 = require("./modules/common/services/applicationservice");
const UserService_1 = require("./modules/users/UserService");
const folioservice_1 = require("./modules/folio/services/folioservice");
const imageservice_1 = require("./modules/images/services/imageservice");
const loginservice_1 = require("./modules/login/services/loginservice");
const uploadservice_1 = require("./modules/upload/services/uploadservice");
const uploadfilestable_1 = require("./modules/upload/directives/uploadfilestable");
const uploadprogressbar_1 = require("./modules/upload/directives/uploadprogressbar");
const pumaimage_1 = require("./modules/images/directives/pumaimage");
const bytes_1 = require("./modules/common/filters/bytes");
const assetformatlabels_1 = require("./modules/images/directives/assetformatlabels");
// framebusting technique
if (self === top) {
    document.documentElement.style.display = 'block';
}
else {
    top.location = self.location.href;
}
var app;
(function (app) {
    angular.module('modules/common', [])
        .service('toolbox', toolbox_1.Toolbox)
        .service('applicationService', applicationservice_1.ApplicationService)
        .filter('bytes', bytes_1.bytes);
    angular.module('modules/users', ['modules/common'])
        .service('userService', UserService_1.UserService);
    angular.module('modules/login', ['modules/common', 'modules/users'])
        .service('loginService', loginservice_1.LoginService);
    angular.module('modules/settings', ['modules/common', 'modules/users'])
        .service('settingsService', settingsservice_1.SettingsService);
    angular.module('modules/upload', [])
        .service('uploadService', uploadservice_1.UploadService)
        .directive('uploadFilesTable', uploadfilestable_1.uploadFilesTable)
        .directive('uploadProgressbar', uploadprogressbar_1.uploadProgressbar);
    angular.module('modules/folio', ['modules/common', 'modules/upload'])
        .service('folioService', folioservice_1.FolioService);
    angular.module('modules/images', ['modules/common', 'modules/upload'])
        .constant('assetFormats', ['jpg', 'gif', 'tiff', 'png', 'bmp', 'svg'])
        .service('imageService', imageservice_1.ImageService)
        .directive('pumaImage', pumaimage_1.pumaImage)
        .directive('assetFormatLabels', assetformatlabels_1.assetFormatLabels);
    // If you remove this line dependencies don't get loaded but are optimized away
    const dependenciesInConstantToPreventTreeshaking = [ngRoute, ngAnimate, ngResource, ngSanitize, uiBootstrap, ngFileUpload, angularGrowl];
    var dependencies = [
        // Thirdparty
        'ngRoute',
        'ngAnimate',
        'ngResource',
        'ngSanitize',
        'ui.bootstrap',
        'ngFileUpload',
        'angular-growl',
        // App
        'modules/common',
        'modules/images',
        'modules/users',
        'modules/folio',
        'modules/settings',
        'modules/upload',
        'modules/login'
    ];
    angular.module('app', dependencies)
        .controller('IndexController', index_controller_1.IndexController)
        .controller('AfbeeldingenController', afbeeldingen_controller_1.AfbeeldingenController)
        .controller('FolioController', folio_controller_1.FolioController)
        .controller('InstellingenController', instellingen_controller_1.InstellingController)
        .controller('LoginController', login_controller_1.LoginController)
        .run(['$rootScope', '$location', 'userService',
        ($rootScope, $location, userService) => {
            var routesThatDontRequireAuth = ['/login'];
            var routeClean = (route) => {
                return _.find(routesThatDontRequireAuth, (noAuthRoute) => {
                    return _.startsWith(route, noAuthRoute);
                });
            };
            $rootScope.$on('$routeChangeStart', (event, next, current) => {
                if (!routeClean($location.url()) && !userService.isUserLoggedIn()) {
                    $location.path('/login');
                }
            });
            $rootScope.$on('sessionsExpired', (event, next, current) => {
                console.log("session expired event received");
                if (userService.removeCurrentUser()) {
                    console.log("location will change expired event received");
                    $location.path('/login');
                }
            });
        }])
        .config(['$routeProvider', '$httpProvider', 'growlProvider',
        ($routeProvider, $httpProvider, growlProvider) => {
            //---------------------------------------------------------------
            // Routes
            //---------------------------------------------------------------
            $routeProvider.
                when('/homepage', { templateUrl: 'views/homepage.html' }).
                when('/afbeeldingen', { templateUrl: 'views/afbeeldingen.html' }).
                when('/folio', { templateUrl: 'views/folio.html' }).
                when('/instellingen', { templateUrl: 'views/instellingen.html' }).
                when('/login', { templateUrl: 'views/login.html' }).
                otherwise({ redirectTo: '/homepage' });
            //---------------------------------------------------------------
            // angular-growl
            //---------------------------------------------------------------
            // Look automatically for messages in $http responses, so your
            // business logic on the server is able to send
            // messages/notifications to the client and you can display them
            // automagically:
            growlProvider.globalDisableCountDown(true);
            growlProvider.globalTimeToLive({ success: 3000, error: -1, warning: 3000, info: 3000 });
            $httpProvider.interceptors.push(growlProvider.serverMessagesInterceptor);
            //---------------------------------------------------------------
            // Default $http interception
            //---------------------------------------------------------------
            const httpInterception = ($q, $rootScope) => {
                return {
                    'request': (config) => {
                        return config || $q.when(config);
                    },
                    'requestError': $q.reject,
                    'response': (response) => response || $q.when(response),
                    'responseError': (rejection) => {
                        var _a, _b, _c;
                        var message;
                        if (rejection.status === 400) {
                            message = "Request ongeldig";
                        }
                        else if (rejection.status === 404) {
                            message = "Niet gevonden";
                        }
                        else if (rejection.status === 500) {
                            if ((_c = (_b = (_a = rejection.data) === null || _a === void 0 ? void 0 : _a.messages[0]) === null || _b === void 0 ? void 0 : _b.text) === null || _c === void 0 ? void 0 : _c.includes('Username not found for identifier')) {
                                message = "Uw sessie is verlopen, log opnieuw in";
                                $rootScope.$emit("sessionsExpired", true);
                            }
                            else {
                                message = "Serverfout";
                            }
                        }
                        if (message) {
                            rejection.data = { messages: [{ text: message }] };
                        }
                        return $q.reject(rejection);
                    }
                };
            };
            httpInterception.$inject = ['$q', '$rootScope'];
            $httpProvider.interceptors.push(httpInterception);
        }
    ]);
})(app || (app = {}));
